import { RestUrl } from "../common/cyan.types";

export class FolderFileUrl {
  public static createDocumentFiles: RestUrl = ["POST", "/files/document"];
  public static createProposalFile: RestUrl = ["POST", "/files/proposal"];
  public static createSignFile: RestUrl = ["POST", "/files/sign"];
  public static getFolderFilePdfConvertQueue: (fileId: bigint) => RestUrl = id => ["GET", `/files/${id}/docs-pdf/convert-queue`];
  public static getFolderFileById: (fileId: bigint) => RestUrl = id => ["GET", `/files/${id}`];
  public static getFolderFileDocsPdfPage: (fileId: bigint, page: number) => RestUrl = (id, page) => [
    "GET",
    `/files/${id}/docs-pdf/pages/${page}`,
  ];
  public static downloadFolderFile: (fileId: bigint) => RestUrl = id => ["POST", `/files/${id}/download`];
  public static removeFolderFileById: (fileId: bigint) => RestUrl = id => ["DELETE", `/files/${id}`];
  public static moveFolderFileById: (fileId: bigint) => RestUrl = id => ["POST", `/files/${id}/move`];
  public static renameFolderFileById: (fileId: bigint) => RestUrl = id => ["POST", `/files/${id}/rename`];
  public static retryConvertFolderFilePdf: (fileId: bigint) => RestUrl = id => ["POST", `/files/${id}/docs-pdf/convert/retry`];
}
